import React from 'react';
import { Button, Collapse, Typography } from '@common-ui/ui';
import notificationEnum from '../../../enums/notificationEnum';
import SyncImagerSVG from './images/sync_imager';

function ButtonLabel({ children }) {
  return <Typography variant="subtitle2">{children}</Typography>;
}

export default function CheckImagerSync({ open, handleAction }) {
  const { confirm, hideRemaining } = notificationEnum.CHECK_IMAGER_SYNC.BUTTON;

  return (
    <Collapse in={open} id="notification-sync-collapsible">
      <div id="notification-sync-panel" style={{ ...styleFlexCol, ...stylePadding }}>
        <SyncImagerSVG id="notification-sync-imager" styles={styleSyncImage} alt="imager-sync" />

        <Button
          id="notification-btn-confirm"
          variant="contained"
          style={styleButton}
          onClick={() => handleAction.confirm()}
        >
          <ButtonLabel>{confirm}</ButtonLabel>
        </Button>

        <Button
          id="notification-btn-confirm-and-hide-remaining"
          variant="outlined"
          style={{ ...styleFlexCol, ...styleButton, backgroundColor: '#F6FAFF' }}
          onClick={() => handleAction.confirmForAll()}
        >
          <ButtonLabel>{confirm}</ButtonLabel>
          <ButtonLabel>{hideRemaining}</ButtonLabel>
        </Button>
      </div>
    </Collapse>
  );
}

const styleFlexCol = {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const stylePadding = {
  width: '100%',
  padding: '16px',
  gap: '16px',
};

const styleButton = {
  height: '100%',
  width: '100%',
  padding: '8px',
  maxWidth: '500px',
};

const styleSyncImage = {
  maxWidth: '200px',
  maxHeight: '246px',
};
